<div class="sidebar" [ngClass]="{'sidebar-hover': collapsed}"  >

<ul class="layout-menu" (click)="removeDriverId()">
    <li class="no-hover">
      <img [src]="logo" alt="Prime Blocks" class="prime-logo mt-3" />
      <img src="assets/images/small-logo.svg" alt="Prime Blocks" class="prime-logo1 mt-3" />
    </li>
    <li *ngIf="isGuestUser" class="active">
      <div class="single-menu">
        <img src="assets/images/sidebar_svg/crt_resrv_mo.svg" alt=""/>
        <span>Create Booking</span>
      </div>
    </li>
    <ng-container *ngFor="let menu of menuObj">
      <li (click)=" menu.submenu?.length == 0" class="manger-user"
        [ngClass]="{'active': menu.isActive}" routerLinkActive="active">
        <ng-container  *ngIf="menu.submenu.length === 0; else hasSubmenu">
          <ng-container *ngIf="menu.actions[0]?.path; else handleClick">
            <ng-container *ngIf="shouldOpenInNewTab(menu.shortName); else internalLink">
              <div (click)="urlOpenInNewTab(menu.actions[0].path);" class="single-menu">
                <img *ngIf="menu.menuImage" [src]="menu.menuImage" alt="" />
                <span>{{ menu.menuName }}</span>
              </div>
            </ng-container>
            <ng-template #internalLink>
              <div [routerLink]="menu.actions[0].path" (click)="closeSideTab()" routerLinkActive="active" class="single-menu">
                <img *ngIf="menu.menuImage" [src]="menu.menuImage" alt="" />
                <span>{{ menu.menuName }}</span>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #handleClick>
            <div class="single-menu" (click)="handleClickEvent(menu.shortName); closeSideTab()">
              <img *ngIf="menu.menuImage" [src]="menu.menuImage" alt="" />
              <span>{{ menu.menuName }}</span>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #hasSubmenu>
          <div class="manager-menu" (click)="toggleSideBar(menu)" [ngClass]="{'active-menu': menu.isShow}">
            <div class="user">
              <img *ngIf="menu.menuImage" [src]="menu.menuImage" alt=""/>
              <span>{{ menu.menuName }}</span>
            </div>
            <em class="pi" [ngClass]="{'pi-angle-up': menu.isShow, 'pi-angle-down': !menu.isShow}"></em>
          </div>
          
          <ul class="sub-menu" *ngIf="menu.isShow">
            <li *ngFor="let submenu of menu.submenu" routerLinkActive="active-submenu" >
              <ng-container *ngIf="submenu.actions[0]?.path; else handleClickSubmenu">
                <ng-container *ngIf="shouldOpenInNewTab(submenu.shortName); else internalSubLink">
                  <a [href]="submenu.actions[0].path" target="_blank" rel="noopener" class="single-menu">
                    <img [src]="submenu.menuImage" alt="" />
                    <span>{{ submenu.name }}</span>
                  </a>
                </ng-container>
                <ng-template #internalSubLink>
                  <a (click)="closeSbmenu(submenu)" [routerLink]="submenu.actions[0].path" routerLinkActive="active" class="single-menu">
                    <img [src]="submenu.menuImage" alt="" />
                    <span>{{ submenu.name }}</span>
                  </a>
                </ng-template>
              </ng-container>
              <ng-template #handleClickSubmenu>
                <div class="single-menu" (click)="handleClickEvent(submenu.shortName)">
                  <img [src]="submenu.menuImage" alt="" />
                  <span>{{ submenu.name }}</span>
                </div>
              </ng-template>
            </li>
          </ul>
        </ng-template>
      </li>
    </ng-container>
    <li class="logout-outer" *ngIf="!isGuestUser && menuObj?.length >0" (click)="logout()">
      <img src="assets/images/sidebar_svg/log.svg" alt=""/><span>Logout</span>
    </li>
  
    <li [ngClass]="{'sidebarclosed':( _isSidebarOpen && !collapsed)}" *ngIf="version" class="version-outer"> <img src="assets/images/sidebar_svg/version-icon.svg" alt=""/><span>Version: {{version}}</span></li>
  </ul>
</div>
